import { render, staticRenderFns } from "./personalisationInline.vue?vue&type=template&id=2fa12c14&"
import script from "./personalisationInline.vue?vue&type=script&lang=js&"
export * from "./personalisationInline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa12c14')) {
      api.createRecord('2fa12c14', component.options)
    } else {
      api.reload('2fa12c14', component.options)
    }
    module.hot.accept("./personalisationInline.vue?vue&type=template&id=2fa12c14&", function () {
      api.rerender('2fa12c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/pages/productAside/Actions/personalisationInline.vue"
export default component.exports